import {Input} from "../Form/types";
import {createFileInput} from "../Form/Input";
import {__} from "@wordpress/i18n";

export const InputApplicationDocuments = (el: HTMLElement|null) => {
    return el
        ? createFileInput( el as HTMLInputElement, ( input: Input, value: Array<string> ): void => {

        } )
        : null;
}
